var render = function render(){
  var _vm$value, _vm$value2;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('v-row', [_c('v-col', [_c('v-layout', {
    attrs: {
      "align-center": ""
    }
  }, [_c('h3', {
    staticClass: "tit mr-4"
  }, [_vm._v(" " + _vm._s(_vm.name) + " ")]), _c('p', {
    staticClass: "page-text--lg grey-6--text"
  }, [_vm._v("(" + _vm._s(_vm.gender) + " / " + _vm._s(_vm.age) + ")")])]), _vm.appliedAt ? _c('p', {
    staticClass: "page-text--sm grey-b3--text"
  }, [_vm._v("지원일시: " + _vm._s(_vm.appliedAt))]) : _vm._e()], 1), _c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('like-btn', {
    attrs: {
      "params": {
        _userPerson: (_vm$value = _vm.value) === null || _vm$value === void 0 ? void 0 : _vm$value._applicant,
        type: _vm.USER_LIKE_TYPES.BLACKLISTED.value
      }
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function (_ref) {
        var active = _ref.active,
          toggle = _ref.toggle;
        return [_c('v-btn', {
          attrs: {
            "icon": "",
            "text": "",
            "small": "",
            "color": active ? 'red' : undefined
          },
          on: {
            "!click": function ($event) {
              $event.stopPropagation();
              $event.preventDefault();
              return toggle.apply(null, arguments);
            }
          }
        }, [_c('v-icon', {
          attrs: {
            "small": ""
          }
        }, [_vm._v(_vm._s(active ? "mdi-account-cancel" : "mdi-account-cancel-outline"))])], 1)];
      }
    }])
  })], 1), _c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('like-btn', {
    attrs: {
      "params": {
        _application: (_vm$value2 = _vm.value) === null || _vm$value2 === void 0 ? void 0 : _vm$value2._id,
        type: _vm.USER_LIKE_TYPES.APPLICATION.value
      }
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function (_ref2) {
        var active = _ref2.active,
          toggle = _ref2.toggle;
        return [_c('v-btn', {
          attrs: {
            "icon": "",
            "text": "",
            "small": "",
            "color": active ? 'yellow darken-1' : undefined
          },
          on: {
            "!click": function ($event) {
              $event.stopPropagation();
              $event.preventDefault();
              return toggle.apply(null, arguments);
            }
          }
        }, [_c('v-icon', [_vm._v(_vm._s(active ? "mdi-star" : "mdi-star-outline"))])], 1)];
      }
    }])
  })], 1), _c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('application-print', _vm._b({
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function (_ref3) {
        var attrs = _ref3.attrs,
          on = _ref3.on;
        return [_c('v-btn', _vm._g(_vm._b({
          attrs: {
            "icon": "",
            "text": "",
            "small": ""
          }
        }, 'v-btn', attrs, false), on), [_c('v-icon', [_vm._v("mdi-printer")])], 1)];
      }
    }])
  }, 'application-print', {
    value: _vm.value
  }, false))], 1)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }